import { LegalPageLayout } from './LegalPageLayout';

export function CartaValoriPage() {
  return (
    <LegalPageLayout title="Carta dei Valori">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <p>
                      Klaro7 nasce con l&apos;obiettivo di offrire un servizio di consulenza basato su
                      professionalità, rispetto e trasparenza, mettendo al centro il benessere e la libertà
                      di scelta degli utenti.
                    </p>
                    <p>
                      Crediamo che la cartomanzia, quando praticata con responsabilità e consapevolezza,
                      possa rappresentare uno strumento di riflessione e confronto personale.
                    </p>
                    <p>
                      Per questo motivo Klaro7 si fonda su alcuni valori fondamentali che guidano il lavoro
                      della piattaforma e dei suoi consulenti.
                    </p>
      
                    <h2>Centralità della persona</h2>
                    <p>
                      Ogni utente è prima di tutto una persona con la propria storia, le proprie emozioni e
                      i propri dubbi.
                    </p>
                    <p>
                      Per questo motivo i consulenti Klaro7 si impegnano a offrire ascolto, rispetto e
                      sensibilità, evitando qualsiasi forma di giudizio o pressione.
                    </p>
                    <p>Il consulto deve rappresentare uno spazio di dialogo sereno e rispettoso.</p>
      
                    <h2>Professionalità dei consulenti</h2>
                    <p>Klaro7 seleziona con attenzione i propri consulenti, valutando:</p>
                    <ul>
                      <li>esperienza</li>
                      <li>capacità di ascolto</li>
                      <li>correttezza professionale</li>
                      <li>rispetto delle regole della piattaforma</li>
                    </ul>
                    <p>
                      Il nostro obiettivo è garantire agli utenti un servizio basato su serietà e qualità
                      delle consulenze.
                    </p>
      
                    <h2>Trasparenza del servizio</h2>
                    <p>La trasparenza è uno dei principi fondamentali della piattaforma.</p>
                    <p>Gli utenti devono poter conoscere in modo chiaro:</p>
                    <ul>
                      <li>le modalità di funzionamento del servizio</li>
                      <li>i costi delle consulenze</li>
                      <li>il sistema di credito e ricarica</li>
                      <li>il funzionamento dei bonus e delle promozioni</li>
                    </ul>
                    <p>
                      Klaro7 si impegna a comunicare sempre queste informazioni in modo semplice e
                      comprensibile.
                    </p>
      
                    <h2>Cartomanzia responsabile</h2>
                    <p>Klaro7 promuove un approccio responsabile alla cartomanzia.</p>
                    <p>Le consulenze non devono mai essere considerate come una sostituzione di:</p>
                    <ul>
                      <li>consulenze mediche</li>
                      <li>consulenze legali</li>
                      <li>consulenze finanziarie</li>
                      <li>supporto psicologico professionale</li>
                    </ul>
                    <p>
                      La cartomanzia deve essere vissuta come uno strumento di riflessione e confronto, nel
                      rispetto della libertà e dell&apos;autonomia della persona.
                    </p>
      
                    <h2>Tutela degli utenti</h2>
                    <p>
                      La piattaforma adotta sistemi di controllo per garantire la qualità delle consulenze.
                    </p>
                    <p>Tra questi:</p>
                    <ul>
                      <li>sistema di recensioni degli utenti</li>
                      <li>monitoraggio della qualità del servizio</li>
                      <li>ranking dei consulenti basato sulle valutazioni</li>
                    </ul>
                    <p>
                      Questo sistema consente di mantenere standard professionali elevati e di migliorare
                      continuamente l&apos;esperienza degli utenti.
                    </p>
      
                    <h2>Rispetto e riservatezza</h2>
                    <p>
                      La riservatezza è un elemento fondamentale del rapporto tra consulente e utente.
                    </p>
                    <p>
                      Tutte le informazioni condivise durante i consulti devono essere trattate con la
                      massima discrezione e rispetto della privacy.
                    </p>
      
                    <h2>Un impegno continuo</h2>
                    <p>
                      Klaro7 si impegna a migliorare costantemente i propri servizi, mantenendo come
                      riferimento i valori di:
                    </p>
                    <ul>
                      <li>rispetto</li>
                      <li>professionalità</li>
                      <li>correttezza</li>
                      <li>responsabilità</li>
                    </ul>
                    <p>
                      Il nostro obiettivo è creare una piattaforma affidabile, dove gli utenti possano
                      trovare ascolto, consulenza e confronto in un ambiente sicuro e trasparente.
                    </p>
    </LegalPageLayout>
  );
}
